import React from 'react';

import { Consulting } from '@layouts/Consulting';
import { DescriptionWithImage, QuoteWithButtons } from '@components';
import { contacts } from '@store/ContactData';
import timeAndMaterial from '@static/images/figures/time-and-material.webp';
import calculator from '@static/images/figures/calculator.webp';
import { Header, HowWeWork } from './components';

import * as styles from './TimeAndMaterial.module.scss';

export const TimeAndMaterial: React.FC = () => {
	return (
		<>
			<Header />
			<DescriptionWithImage
				image={timeAndMaterial}
				className="gray-bg"
				imageOnRight
				disableContentPadding
				imageBoxClassName="justify-content-end"
				imageClassName={styles.image}
			>
				<h2 className="font-600 mb-2">Is time &#38; material for me?</h2>
				<p className="font-size-sm mb-4 line-height-sm">
					The Time and Material model is a fantastic option if you want to build
					an optimal team with a wide range of capabilities. Also, If you have
					an idea or plan for your project but are missing the team, Time &#38;
					Material will suit you. The project Manager will lead the whole
					project and engage the best team configuration.
				</p>
				<p className="font-size-sm line-height-sm">
					The significant advantage of this model is the fact that the team is
					built only with the professionals, who are needed at the moment.
					Depending on demand, specialists in the project change from stage to
					stage.
				</p>
			</DescriptionWithImage>
			<HowWeWork />
			<DescriptionWithImage
				image={calculator}
				className="gray-bg"
				imageClassName={styles.calculatorImage}
				imageBoxClassName="justify-content-center justify-content-md-end"
				imageOnRight
			>
				<h2 className="font-600 mb-2">
					How do you calculate time &#38; material?
				</h2>
				<div className="font-size-sm line-height-sm">
					Time &#38; Materials model is billed in spent time. The customer
					covers the cost of time and material. Every time client accepts both -
					the time we intend to spend on his project and the purchases to be
					made, some sub-assemblies, sensors, PCB boards, this is the cost of
					materials.
				</div>
			</DescriptionWithImage>
			<QuoteWithButtons
				author={{
					name: contacts[0].name,
					position: contacts[0].position,
					email: contacts[0].email,
					linkedIn: contacts[0].linkedin,
					photo: contacts[0].image,
				}}
			>
				<h2 className="font-size-22 font-600 mb-2 pr-5">
					What kind of competencies are you looking for?
				</h2>
				<p className="font-size-sm line-height-sm">
					Contact me to discuss your requirements and build your dedicated IT
					team together with us.{' '}
				</p>
			</QuoteWithButtons>
			<Consulting />
		</>
	);
};
